package com.eladfinish.bible.contest.extensions

val MatchResult.start: Int
    get() = this.range.first

val MatchResult.end: Int
    get() = this.range.last.plus(1)

val MatchResult.groupCount: Int
    get() = this.groupValues.size
